import React, {useMemo} from "react";
import {FormattedMessage} from "react-intl";
import useTenant from "../hooks/useTenant";

export const  FormattedMessageCustom = ({id}: {id: string}) => {

  const tenant = useTenant()

  const labelId = useMemo(() => {
    if(tenant.id === 18){
      if(id === "progetti.internal_responsible"  ){
        return "progetti.commercial_responsible"
      }
      if(id === "progetti.collaborator"){
        return "progetti.project_responsible"
      }
    }

    return id
  }, [id, tenant.id])


  return <FormattedMessage id={labelId} />
}
